//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionMixin from '~/mixins/section'

export default {
  mixins: [SectionMixin],
  data () {
    return {
      activeQuote: 0
    }
  },
  computed: {
    quotes () {
      return this.$t('general.pressQuotes')
    },
    quoteText () {
      return this.quotes[this.activeQuote].description
    }
  },
  methods: {
    onQuoteClicked (i) {
      this.activeQuote = i
    }
  }
}
